import React, { useState } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Card, Form, Button, Alert, Container } from 'react-bootstrap';
import * as Icon from 'react-feather';

function ChangePassword() {
    const authHeader = useAuthHeader();
    const apiUrl = process.env.REACT_APP_URL;

    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        if (newPassword !== confirmPassword) {
            setError('Las contrasenas no coinciden');
            return;
        }

        if (newPassword.length < 6) {
            setError('La nueva contrasena debe tener al menos 6 caracteres');
            return;
        }

        setLoading(true);
        try {
            const res = await axios.put(`${apiUrl}/users/change_password`, {
                current_password: currentPassword,
                new_password: newPassword,
            }, {
                headers: { Authorization: authHeader() }
            });
            setSuccess(res.data.msg);
            setCurrentPassword('');
            setNewPassword('');
            setConfirmPassword('');
        } catch (err) {
            setError(err.response?.data?.error || 'Error al cambiar contrasena');
        }
        setLoading(false);
    };

    return (
        <Container style={{ maxWidth: '500px' }}>
            <Card className="border-0 shadow-sm">
                <Card.Header className="bg-white">
                    <h6 className="mb-0">
                        <Icon.Lock size={18} className="me-2" />
                        Cambiar Contrasena
                    </h6>
                </Card.Header>
                <Card.Body>
                    {error && <Alert variant="danger" dismissible onClose={() => setError(null)}>{error}</Alert>}
                    {success && <Alert variant="success" dismissible onClose={() => setSuccess(null)}>{success}</Alert>}

                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Contrasena Actual</Form.Label>
                            <Form.Control
                                type="password"
                                value={currentPassword}
                                onChange={(e) => setCurrentPassword(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Nueva Contrasena</Form.Label>
                            <Form.Control
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                                minLength={6}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Confirmar Nueva Contrasena</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                required
                                minLength={6}
                            />
                        </Form.Group>
                        <Button type="submit" variant="primary" disabled={loading} className="w-100">
                            {loading ? 'Guardando...' : 'Cambiar Contrasena'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default ChangePassword;
